"use strict";

var unitas = unitas || {};
const multipleForms = document.querySelectorAll('.js-multiple-form');

unitas.multipleForms =
  unitas.multipleForms ||
  (function() {
    function init() {
        if(multipleForms.length > 0) {
            for (let i = 0; i < multipleForms.length; i++) {
                const currentForm = multipleForms[i];
                const tabs = currentForm.querySelectorAll('.js-multiple-form-tab');

                if(tabs.length > 0) {
                    for (let x = 0; x < tabs.length; x++) {
                        const currentTab = tabs[x];
                        
                        currentTab.addEventListener('click', function(e) {
                            const clickedTab = e.currentTarget;
                            const tabId = clickedTab.dataset.id;
                            const matchingForm = currentForm.querySelector('.js-multiple-form-form[data-id="' + tabId + '"]');
                            const visibleForm = currentForm.querySelector('.block-multiple-forms-form--visible');
                            const visibleTab = currentForm.querySelector('.block-multiple-forms-tabs__trigger--visible');

                            visibleTab.classList.remove('block-multiple-forms-tabs__trigger--visible');
                            clickedTab.classList.add('block-multiple-forms-tabs__trigger--visible');
                            visibleForm.classList.remove('block-multiple-forms-form--visible');
                            matchingForm.classList.add('block-multiple-forms-form--visible');
                        });
                    }
                }
            }
        }
    }
    return {
      init: init,
    };
  })();
